/** @format */

export default class Toggle {
	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new Toggle();
		self.attachEvents();
	}

	attachEvents() {
		const self = this;

		$(document).on("change", ".js-toggle-target", function () {
			self.toggleTarget($(this));
		});

		// run on page load if checkboxes may be pre-checked
		$(".js-toggle-target").each(function () {
			self.toggleTarget($(this));
		});
	}

	toggleTarget($checkbox) {
		const targetSelector = $checkbox.data("toggle-target");
		const $target = $(targetSelector);

		if ($target.length === 0) return;

		if ($checkbox.is(":checked")) {
			this.showTarget($target);
		} else {
			this.hideTarget($target);
		}
	}

	showTarget($target) {
		$target.stop(true, true).slideDown(200);
	}

	hideTarget($target) {
		$target.stop(true, true).slideUp(200);
	}
}
